export default __webpack_public_path__ + "static/media/NBA.03072465.png";